import React, { useState, useEffect } from 'react';
import styles from './GalereyaOnboarding.module.css';

const GalereyaOnboarding = () => {
  const [employees, setEmployees] = useState([]);
  const [offices, setOffices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedOffice, setSelectedOffice] = useState('');
  const [feedback, setFeedback] = useState('');
  const [photos, setPhotos] = useState({
    main: null,
    right: null,
    left: null,
    below: null
  });
  const [submissionStatus, setSubmissionStatus] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://5zbcsztftk.execute-api.eu-west-1.amazonaws.com/default/prod-user-list-api', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            "sort_key": "glra12a4a6"
          })
        });
        
        if (!response.ok) {
          throw new Error('Ошибка при загрузке данных');
        }
        
        const data = await response.json();
        setOffices(data.office_list);
        setEmployees(data.data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleEmployeeSelect = (e) => {
    const selectedId = e.target.value;
    if (selectedId === '') {
      setSelectedEmployee(null);
      return;
    }
    const employee = employees.find(emp => 
      `${emp.user_surname} ${emp.user_name}` === selectedId
    );
    setSelectedEmployee(employee);
  };

  const handlePhotoUpload = (type, e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setPhotos(prev => ({
        ...prev,
        [type]: reader.result
      }));
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedEmployee || !selectedOffice) {
      setSubmissionStatus('Пожалуйста, заполните все обязательные поля');
      return;
    }

    const photoArray = [
      photos.main,
      photos.right,
      photos.left,
      photos.below
    ].filter(photo => photo !== null);

    const payload = {
      "place_id": "glra12a4a6",
      "properties": {
        "emp_department": selectedEmployee.emp_department,
        "emp_unit": selectedEmployee.emp_unit,
        "emp_subunit": selectedEmployee.emp_subunit,
        "emp_position": selectedEmployee.emp_position,
        "emp_category": "Сотрудник",
        "user_gender": selectedEmployee.user_gender,
        "emp_city": selectedEmployee.emp_city,
        "emp_office": selectedOffice,
        "user_feedback": feedback
      },
      "user_name": selectedEmployee.user_name,
      "user_surname": selectedEmployee.user_surname,
      "data_url": photoArray
    };

    try {
      const response = await fetch('https://ste1h7g7s7.execute-api.eu-west-1.amazonaws.com/LoyaltySystem1/UserRecords', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error('Ошибка при отправке данных');
      }

      const result = await response.json();
      setSubmissionStatus(`Успешно отправлено! Статус: ${result.user_status || 'Данные сохранены'}`);
    } catch (err) {
      setSubmissionStatus(`Ошибка: ${err.message}`);
    }
  };

  if (loading) {
    return <div className={styles.loading}>Загрузка данных...</div>;
  }

  if (error) {
    return <div className={styles.error}>Ошибка: {error}</div>;
  }

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Регистрационная форма</h1>
      
      <form onSubmit={handleSubmit} className={styles.form}>
        <div className={styles.formGroup}>
          <label htmlFor="employee">Сотрудник*</label>
          <select 
            id="employee" 
            onChange={handleEmployeeSelect}
            required
            className={styles.select}
          >
            <option value="">Выберите сотрудника</option>
            {employees.map((emp, index) => (
              <option key={index} value={`${emp.user_surname} ${emp.user_name}`}>
                {emp.user_surname} {emp.user_name}
              </option>
            ))}
          </select>
        </div>

        {selectedEmployee && (
          <div className={styles.employeeInfo}>
            <h3>Информация о сотруднике</h3>
            <div className={styles.readOnlyField}>
              <label>Пол</label>
              <input 
                type="text" 
                value={selectedEmployee.user_gender === 'Male' ? 'Мужской' : 'Женский'} 
                readOnly 
              />
            </div>
            <div className={styles.readOnlyField}>
              <label>Город</label>
              <input type="text" value={selectedEmployee.emp_city} readOnly />
            </div>
            <div className={styles.readOnlyField}>
              <label>Департамент</label>
              <input type="text" value={selectedEmployee.emp_department} readOnly />
            </div>
            <div className={styles.readOnlyField}>
              <label>Отдел</label>
              <input type="text" value={selectedEmployee.emp_unit} readOnly />
            </div>
            <div className={styles.readOnlyField}>
              <label>Подразделение</label>
              <input 
                type="text" 
                value={selectedEmployee.emp_subunit.join(', ')} 
                readOnly 
              />
            </div>
            <div className={styles.readOnlyField}>
              <label>Должность</label>
              <input type="text" value={selectedEmployee.emp_position} readOnly />
            </div>
          </div>
        )}

        <div className={styles.formGroup}>
          <label htmlFor="office">Офис*</label>
          <select 
            id="office" 
            value={selectedOffice}
            onChange={(e) => setSelectedOffice(e.target.value)}
            required
            className={styles.select}
          >
            <option value="">Выберите офис</option>
            {offices.map((office, index) => (
              <option key={index} value={office}>{office}</option>
            ))}
          </select>
        </div>

        <div className={styles.formGroup}>
          <label htmlFor="feedback">Обратная связь (макс. 100 символов)</label>
          <textarea
            id="feedback"
            value={feedback}
            onChange={(e) => setFeedback(e.target.value.slice(0, 100))}
            maxLength={100}
            className={styles.textarea}
            placeholder="Ваш отзыв или комментарий"
          />
          <div className={styles.charCount}>{feedback.length}/100</div>
        </div>

        <div className={styles.photoSection}>
          <h3>Фотографии</h3>
          
          <div className={styles.photoGroup}>
            <label>Основное фото</label>
            <input 
              type="file" 
              accept="image/*" 
              onChange={(e) => handlePhotoUpload('main', e)}
              className={styles.fileInput}
            />
            {photos.main && (
              <div className={styles.previewContainer}>
                <img src={photos.main} alt="Main preview" className={styles.previewImage} />
              </div>
            )}
          </div>

          <div className={styles.photoGroup}>
            <label>Правая сторона</label>
            <input 
              type="file" 
              accept="image/*" 
              onChange={(e) => handlePhotoUpload('right', e)}
              className={styles.fileInput}
            />
            {photos.right && (
              <div className={styles.previewContainer}>
                <img src={photos.right} alt="Right preview" className={styles.previewImage} />
              </div>
            )}
          </div>

          <div className={styles.photoGroup}>
            <label>Левая сторона</label>
            <input 
              type="file" 
              accept="image/*" 
              onChange={(e) => handlePhotoUpload('left', e)}
              className={styles.fileInput}
            />
            {photos.left && (
              <div className={styles.previewContainer}>
                <img src={photos.left} alt="Left preview" className={styles.previewImage} />
              </div>
            )}
          </div>

          <div className={styles.photoGroup}>
            <label>Снизу</label>
            <input 
              type="file" 
              accept="image/*" 
              onChange={(e) => handlePhotoUpload('below', e)}
              className={styles.fileInput}
            />
            {photos.below && (
              <div className={styles.previewContainer}>
                <img src={photos.below} alt="Below preview" className={styles.previewImage} />
              </div>
            )}
          </div>
        </div>

        <button type="submit" className={styles.submitButton}>Отправить</button>
        
        {submissionStatus && (
          <div className={submissionStatus.includes('Ошибка') ? styles.error : styles.success}>
            {submissionStatus}
          </div>
        )}
      </form>
    </div>
  );
};

export default GalereyaOnboarding;